import React from "react";
import InputMask from "react-input-mask";
import {Form, Input} from "antd";

const inputs = [
  {name: 'login', placeholder: 'Введите логин', label: 'Логин'},
  {name: 'email', placeholder: 'Введите почту', label: 'Почта', rule: {type: 'email', message: 'Введите корректную почту'}},
  {name: 'phone', placeholder: 'Введите номер телефона', label: 'Номер телефона', mask: '+7 (999) 999-99-99'},
  {name: 'name', placeholder: 'Введите имя', label: 'Имя'},
  {name: 'lastName', placeholder: 'Введите фамилию', label: 'Фамилия'},
]

export const Inputs = ({editMode, formItemLayout}) => {
  return (
    <>
      {inputs.map(({name, placeholder, label, mask, rule}) => {
        const validateRules = [{ required: true, message: `Пожалуйста, ${placeholder.toLowerCase()}` }]
        if (rule) validateRules.push(rule)
        return (
          <Form.Item
            {...formItemLayout}
            label={label}
            name={name}
            rules={validateRules}
            key={name}
          >
            {mask
              ? <InputMask mask={mask}>
                {inputProps =>  <Input {...inputProps} placeholder={placeholder} autoComplete="off"/>}
              </InputMask>
              : <Input placeholder={placeholder} />
            }
          </Form.Item>
        )
      })}
      {!editMode
        ? <Form.Item
          {...formItemLayout}
          label='Пароль'
          name='password'
          rules={[{ required: true, message: 'Пожалуйста, введите пароль' }]}
        >
          <Input.Password placeholder='Введите пароль'/>
        </Form.Item>
        : <>
          <Form.Item
            {...formItemLayout}
            label='Новый пароль'
            name='newPassword'
          >
            <Input.Password placeholder='Введите новый пароль'/>
          </Form.Item>
        <Form.Item
          {...formItemLayout}
          label='Повторите новый пароль'
          name='confirmPassword'
          dependencies={['newPassword']}
          rules={[
            ({ getFieldValue}) => ({
              validator(_, value) {
                if (getFieldValue('newPassword') && !value) {
                  return Promise.reject(new Error('Пожалуйста, подтвердите пароль'))
                }
                return Promise.resolve()
              }
            }),
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('newPassword') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('Пароли не совпадают!'));
              },
            }),
          ]}
        >
          <Input.Password placeholder='Введите новый пароль'/>
        </Form.Item>
        </>
      }
    </>
  )
}
